import { CartAddEvent } from '@theme/events';
import { novaCartAdd } from './nova-cart-request.js';

// Zoe Sydney card interaction, adapted to Horizon's native cart events and locale routes.
class NovaCrosssell extends HTMLElement {
  connectedCallback() {
    if (this.bound) { this.observer?.observe(this); return; }
    this.bound = true;
    this.addEventListener('change', e => {
      const card = e.target.closest('.nova-xs-up-card');
      if (card) this.sync(card);
    });
    this.addEventListener('click', e => this.click(e));
    this.addEventListener('scroll', () => this.nav(), true);
    this.observer = new ResizeObserver(() => this.nav());
    this.observer.observe(this);
    this.load();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
  async load() {
    for (const url of [this.dataset.fallback]) {
      try {
        const response = await fetch(url);
        if (!response.ok) continue;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-nova-xs-results]');
        if (!results?.querySelector('.nova-xs-up-card')) continue;
        if (!this.isConnected) return;
        this.querySelector('.nova-xs-up-mount').innerHTML = results.innerHTML;
        this.querySelectorAll('.nova-xs-up-card').forEach(c => this.sync(c));
        this.nav();
        return;
      } catch (_) { /* Continue to the next recommendation source. */ }
    }
  }
  sync(card) {
    const variants = JSON.parse(card.querySelector('.nova-xs-up-vjson').textContent);
    const options = [...card.querySelectorAll('select')].map(s => s.value);
    const variant = options.length ? variants.find(v => v.opts.every((o,i) => o === options[i])) : variants[0];
    const button = card.querySelector('.nova-xs-up-add');
    button.disabled = !variant?.available;
    button.dataset.variantId = variant?.id || '';
    button.querySelector('.nova-xs-up-add-label').textContent = variant?.available ? this.dataset.add : this.dataset.sold;
    const plus = button.querySelector('.nova-xs-up-plus');
    if (plus) plus.hidden = !variant?.available;
    if (!variant) return;
    card.querySelector('.nova-xs-up-now').textContent = variant.price;
    let compare = card.querySelector('.nova-xs-up-was');
    if (!compare) { compare = document.createElement('s'); compare.className = 'nova-xs-up-was'; card.querySelector('.nova-xs-up-price').append(compare); }
    compare.textContent = variant.compare;
    compare.hidden = !variant.sale;
    if (variant.img) card.querySelector('img').src = variant.img;
  }
  nav() {
    const track = this.querySelector('.nova-xs-up-track');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    this.querySelector('.nova-xs-up-prev').hidden = max < 4 || track.scrollLeft <= 2;
    this.querySelector('.nova-xs-up-next').hidden = max < 4 || track.scrollLeft >= max - 2;
  }
  async click(event) {
    const arrow = event.target.closest('.nova-xs-up-nav');
    if (arrow) {
      const track = this.querySelector('.nova-xs-up-track');
      const width = track.querySelector('.nova-xs-up-card').getBoundingClientRect().width + 12;
      track.scrollBy({left: arrow.classList.contains('nova-xs-up-prev') ? -width : width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const button = event.target.closest('.nova-xs-up-add');
    if (!button || button.disabled) return;
    button.disabled = true;
    const error = this.querySelector('.nova-xs-error');
    error.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
      const response = await novaCartAdd(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:button.dataset.variantId,quantity:1}],sections,sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      document.dispatchEvent(new CartAddEvent(result, this.id || 'nova-crosssell', {source:'product-form-component', sections:result.sections, itemCount:1, variantId:button.dataset.variantId}));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        await customElements.whenDefined('cart-drawer-component');
        drawer.open();
      }
      else location.assign(root + 'cart');
    } catch (e) { error.textContent = e.message || this.dataset.error; }
    finally { button.disabled = false; }
  }
}
if (!customElements.get('nova-crosssell')) customElements.define('nova-crosssell', NovaCrosssell);
